import styled from 'styled-components'
import Text from 'ui/Text'

export const SEARCH_ID = 'games-searched'

const SearchResult = styled(Text).attrs({ id: SEARCH_ID })``

export default SearchResult
